export class DocumentInfo {
  public Comments: string;
  public DocumentType: string;
  public FileName: string;
  public FileSizeBytes: number;
  public ImageId: string;
  public ScanDate: Date;
}
